export default "__VITE_ASSET__DXrxhh0N__"